
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'container': {'display': `flex`,'justifyContent': `center`,'marginTop': `3%`,},'circle': {'overflow': `hidden`,'backgroundColor': `#282828`,'borderRadius': `100px`,'borderWidth': `5px`,'borderColor': `#ffffff`,'width': `180px`,'height': `180px`,'display': `flex`,'flexDirection': `column`,'justifyContent': `flex-end`,},'circleFill': {'width': `100%`,'backgroundColor': `#be1e2d`,'borderTopColor': `#aeaeae`,'borderTopWidth': `0px`,'height': `0%`,},'circleFillLogo': {'alignSelf': `center`,'position': `absolute`,'width': `120px`,'height': `auto`,'paddingBottom': `30px`,},
        
      };
    };
  